module.exports = __webpack_public_path__ + "static/media/sistem-frenimi.b22c6a80.jpg";